module.exports = __webpack_public_path__ + "img/67.4.NH3-N.5f48b037.png";